// extracted by mini-css-extract-plugin
export var label = "_gg-2";
export var slideContainer = "_gg-0";
export var slider = "_gg-1";